const sessionKey = 'kL6OHTH90yVmTJ23o3aE7xFhtOOOQL';
export const getSession = () => {
  const session = localStorage.getItem(sessionKey);
  if (!session) return null;

  return JSON.parse(atob(session));
};

export const setSessionInLocalStorage = (
  accessToken,
  refreshToken,
  accessExpiresAt,
  refreshExpiresAt
) => {
  if (accessToken && refreshToken) {
    const session = {
      accessToken,
      refreshToken,
      accessExpiresAt,
      refreshExpiresAt
    };

    const sessionEncripted = btoa(JSON.stringify(session));
    localStorage.setItem(sessionKey, sessionEncripted);

    localStorage.setItem('accessToken', accessToken);
    return true;
  }
  localStorage.removeItem(sessionKey);
  return false;
};
